import Portfolio from "../../../commonComponents/portfolio";

const Portfolio4GridContainer = () => {
  return <Portfolio gridSize={4} carShow={12} />;
};

export default Portfolio4GridContainer;
